import { render } from "./GrowthSelect.vue?vue&type=template&id=238ac4e3&scoped=true&ts=true"
import script from "./GrowthSelect.vue?vue&type=script&lang=ts"
export * from "./GrowthSelect.vue?vue&type=script&lang=ts"

import "./GrowthSelect.vue?vue&type=style&index=0&id=238ac4e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238ac4e3"]])

export default __exports__